import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = () => (
  <Helmet>
    <title>Nitin Sharma Photography | Automotive & Lifestyle Photographer</title>
    <meta name="description" content="Professional automotive photography, wedding coverage, event photography, and cinematography by Nitin Sharma. Capturing the essence of speed, elegance, and emotion." />
    <meta name="keywords" content="automotive photography, car photography, wedding photographer, event photography, cinematography, Nitin Sharma, product photography, Mumbai photographer" />
    <meta property="og:title" content="Nitin Sharma Photography | Automotive & Lifestyle Photographer" />
    <meta property="og:description" content="Professional automotive photography and cinematography. Capturing speed, elegance, and emotion." />
    <meta property="og:image" content="https://static.wixstatic.com/media/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg/v1/fill/w_1200,h_630,al_c,q_85,enc_avif,quality_auto/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg" />
    <meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Nitin Sharma Photography" />
    <meta name="twitter:description" content="Professional automotive photography and cinematography." />
    <meta name="twitter:image" content="https://static.wixstatic.com/media/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg/v1/fill/w_1200,h_630,al_c,q_85,enc_avif,quality_auto/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg" />
    <link rel="canonical" href="https://www.nsphotovideo.com" />
    <script type="application/ld+json">{JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Nitin Sharma Photography",
      "description": "Professional automotive photography, wedding coverage, event photography, and cinematography.",
      "image": "https://static.wixstatic.com/media/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg/v1/fill/w_1200,h_630,al_c,q_85,enc_avif,quality_auto/cb9bb3_f8f067d7906b46eb9d7385a2eb171ef2~mv2.jpg",
      "priceRange": "$$",
      "address": { "@type": "PostalAddress", "addressLocality": "Mumbai", "addressCountry": "IN" },
      "sameAs": ["https://instagram.com/nsphotovideo", "https://facebook.com/nsphotovideo", "https://youtube.com/nsphotovideo"]
    })}</script>
  </Helmet>
);

export default SEO;
